<template>
  <div class="carouselOne position-relative">

    <div class="col-md-11 col-12 carouselContainer">
      <div v-if="mobile_component">

        <vitamina-a></vitamina-a>

        <vitamina-c></vitamina-c>

        <vitamina-d></vitamina-d>

        <omega></omega>

        <zinc></zinc>

<!--        <template #customPaging>-->
<!--          <div class="custom-dot">-->
<!--            &lt;!&ndash; {{ page }} &ndash;&gt;-->
<!--          </div>-->
<!--        </template>-->

      </div>
      <carousel :nav="false" :stagePadding=15 :items=1 :center=true v-else-if="!mobile_component" class="immunity-cards-carousel" style="width: 95%; margin: auto">

        <vitamina-a></vitamina-a>

        <vitamina-c></vitamina-c>

        <vitamina-d></vitamina-d>

        <omega></omega>

        <zinc></zinc>

<!--        <template #customPaging>-->
<!--          <div class="custom-dot">-->
<!--            &lt;!&ndash; {{ page }} &ndash;&gt;-->
<!--          </div>-->
<!--        </template>-->

      </carousel>

    </div>

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'


//import cards
import VitaminaA from './CardSlick2/VitaminaA.vue'
import VitaminaC from './CardSlick2/VitaminaC.vue'
import VitaminaD from './CardSlick2/VitaminaD.vue'
import Omega from './CardSlick2/Omega.vue'
import Zinc from './CardSlick2/Zinc.vue'

export default {
  name: 'MyComponent',
  components: {
    carousel,
    'vitamina-a': VitaminaA,
    'vitamina-c': VitaminaC,
    'vitamina-d': VitaminaD,
    'omega': Omega,
    'zinc': Zinc,
  },
  props: ["mobile_component"],
  data() {
    return {
      settings: {
        "dots": true,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 2.2,
        "slidesToScroll": 1,
        "initialSlide": 0,
        "responsive": [
          {
            "breakpoint": 1200,
            "settings": {
              "slidesToShow": 1.5,
              "slidesToScroll": 1,
              "dots": true
            }
          },

          {
            "breakpoint": 992,
            "settings": {
              "slidesToShow": 1.5,
              "slidesToScroll": 1,
              "dots": true

            }
          },
          {
            "breakpoint": 768,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 0,
              "dots": false

            }
          },

        ]
      }
    }
  },
}
</script>

<style scoped lang="scss">
.carouselOne {
  overflow: hidden;
  min-height: 400px;
  margin-bottom: 40px;

  .carouselContainer {
    position: absolute;
    overflow: hidden;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    padding: 0;

    .slick-slider {
      ::v-deep .slick-dots {
        width: inherit;
        right: 25px;

        li {
          margin: 0;
          width: initial;
        }
      }
    }

    .slick-list {
      background-color: red;
      margin: 0 -150px 0 0;

      .slick-slide {
        display: block;
        margin-right: 30px;

        img {
          margin-bottom: 15px;
        }

        .bk-blue-light {
          background: #F2F0ED;
          border-radius: 20px;
          width: 400px !important;
          min-height: 270px;
          max-height: 270px;
          position: relative;
          @media only screen and (max-width: 768px) {
            width: 100% !important;
            min-height: 100%;
            max-height: 100%;
            margin-top: 15px;
          }

          &:focus {
            outline: none;
          }

          p {
            font-size: 14px;
            font-weight: 500;
            color: #029FE3;
          }

          span {
            font-size: 16px;
            font-weight: 500;
            color: #029FE3;
          }
        }

      }

    }
  }
}

ul {
  .custom-dot {
    display: inline-block;
    font-size: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: none;
    background: #029FE3;
    outline: none;
    transition: all 0.2s ease;
    margin-right: 12px;
    cursor: pointer;
    opacity: 0.5;

  }

  .slick-active {
    .custom-dot {
      opacity: 1;
      width: 24px;
      border-radius: 10px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .carouselOne {
    //min-height: 180vh;
    margin-top: 0;

    ::v-deep .slick-slide {
      float: none !important;
    }
  }
}

@media only screen and (max-width: 475px) {
  .carouselOne {
    //min-height: 180vh;
  }



}

@media only screen and (max-width: 360px) {
  .carouselOne {
    min-height: 450px;
  }
}
</style>
